import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { UpdatedDate } from '@/components/LoanTerms/UpdatedDate';
import { BENEFITS, OPTIONS } from './options';
import { LAST_UPDATED } from './constants';
import s from './index.module.scss';

const RefinancingPageV1 = () => {
  const { t } = useTranslation('refinancing');
  const OPTIONS_T = OPTIONS(t);
  const BENEFITS_T = BENEFITS(t);

  return (
    <div className={s.wrapper}>
      <div className="container-inner">
        <h1 className={classnames(s.title)}>{t('page_title')}</h1>

        <div className={s.content}>
          <div className={s.header}>
            <h2 className="f-hero-h4">What is refinancing</h2>
            <div className={classnames('f-body-regular', s.subtitle)}>{t('page_subtitle')}</div>
            <div className={classnames('f-body-regular', s.desc)}>{t('page_desc')}</div>
          </div>

          <div className={s.cards}>
            {OPTIONS_T.map(option => (
              <div key={option.title} className={s.card}>
                <img src={option.icon} alt="icon" width={40} height={40} />
                <div className={s.card_content}>
                  <h3 className="f-body-accent">{option.title}</h3>
                  <p className="f-small-regular">{option.description}</p>
                </div>
                <div className={classnames(s.fee, 'f-article-accent')}>
                  {t('fee', { amount: option.fee })}
                </div>
              </div>
            ))}
          </div>
          <div className={s.section}>
            <h2 className="f-hero-h4">{t('benefit_title')}</h2>
            <ul className={s.benefits}>
              {BENEFITS_T.map(option => (
                <li key={option.title} className={s.benefit}>
                  <div className="f-article-accent">{option.title}</div>
                  <div className="f-body-regular">{option.description}</div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <UpdatedDate className={s.update} date={LAST_UPDATED} />
      </div>
    </div>
  );
};

export default RefinancingPageV1;
